var _desc, _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(30.6818 0 0 30.6818 539.9997 539.9997)",
    id: 831011
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "devops_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,129,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -16)",
    d: "M 18 31.36 h -4 c -0.128 0 -0.248 -0.069 -0.312 -0.181 l -2 -3.464 c -0.064 -0.111 -0.064 -0.248 0 -0.359 l 2 -3.464 c 0.064 -0.111 0.183 -0.181 0.312 -0.181 h 3.792 l 2.896 -5.016 c 0.1 -0.174 0.32 -0.231 0.491 -0.132 c 0.173 0.1 0.231 0.319 0.132 0.491 l -2.896 5.017 l 1.896 3.284 c 0.064 0.111 0.064 0.248 0 0.359 l -2 3.464 C 18.247 31.291 18.129 31.36 18 31.36 z M 14.208 30.64 h 3.584 l 1.792 -3.104 l -1.792 -3.104 h -3.584 l -1.792 3.104 L 14.208 30.64 z M 28 25.593 h -4 c -0.129 0 -0.247 -0.069 -0.312 -0.181 l -2 -3.465 c -0.064 -0.111 -0.064 -0.248 0 -0.359 l 1.896 -3.284 l -2.896 -5.016 c -0.1 -0.172 -0.041 -0.393 0.132 -0.492 c 0.171 -0.1 0.392 -0.041 0.491 0.131 l 2.896 5.016 H 28 c 0.129 0 0.247 0.069 0.312 0.181 l 2 3.464 c 0.064 0.111 0.064 0.248 0 0.359 l -2 3.465 C 28.247 25.523 28.129 25.593 28 25.593 z M 24.208 24.872 h 3.584 l 1.792 -3.104 l -1.792 -3.104 h -3.584 l -1.792 3.104 L 24.208 24.872 z M 8 25.593 H 4 c -0.128 0 -0.248 -0.069 -0.312 -0.181 l -2 -3.465 c -0.064 -0.111 -0.064 -0.248 0 -0.359 l 2 -3.464 C 3.752 18.013 3.872 17.943 4 17.943 h 4 c 0.128 0 0.248 0.069 0.312 0.181 l 1.896 3.283 H 16 c 0.199 0 0.36 0.161 0.36 0.36 s -0.161 0.36 -0.36 0.36 h -5.792 l -1.896 3.284 C 8.248 25.523 8.128 25.593 8 25.593 z M 4.208 24.872 h 3.584 l 1.792 -3.104 l -1.792 -3.104 H 4.208 l -1.792 3.104 L 4.208 24.872 z M 11 19.253 c -0.125 0 -0.246 -0.064 -0.312 -0.181 l -2.896 -5.016 H 4 c -0.128 0 -0.248 -0.068 -0.312 -0.18 l -2 -3.464 c -0.064 -0.111 -0.064 -0.249 0 -0.36 l 2 -3.464 C 3.752 6.477 3.872 6.408 4 6.408 h 4 c 0.128 0 0.248 0.068 0.312 0.18 l 2 3.464 c 0.064 0.111 0.064 0.249 0 0.36 l -1.896 3.284 l 2.896 5.017 c 0.099 0.172 0.04 0.392 -0.132 0.491 C 11.124 19.237 11.062 19.253 11 19.253 z M 4.208 13.336 h 3.584 l 1.792 -3.104 L 7.792 7.128 H 4.208 l -1.792 3.104 L 4.208 13.336 z M 28 14.056 h -4 c -0.129 0 -0.247 -0.068 -0.312 -0.18 l -1.896 -3.285 H 16 c -0.199 0 -0.36 -0.161 -0.36 -0.36 s 0.161 -0.36 0.36 -0.36 h 5.792 l 1.896 -3.284 c 0.064 -0.111 0.183 -0.18 0.312 -0.18 h 4 c 0.129 0 0.247 0.068 0.312 0.18 l 2 3.464 c 0.064 0.111 0.064 0.249 0 0.36 l -2 3.464 C 28.247 13.988 28.129 14.056 28 14.056 z M 24.208 13.336 h 3.584 l 1.792 -3.104 l -1.792 -3.104 h -3.584 l -1.792 3.104 L 24.208 13.336 z M 11 13.484 c -0.061 0 -0.123 -0.015 -0.18 -0.048 c -0.172 -0.1 -0.231 -0.32 -0.132 -0.492 l 2.896 -5.016 l -1.896 -3.284 c -0.064 -0.112 -0.064 -0.249 0 -0.36 l 2 -3.464 C 13.752 0.708 13.872 0.64 14 0.64 h 4 c 0.129 0 0.247 0.068 0.312 0.18 l 2 3.464 c 0.064 0.111 0.064 0.249 0 0.36 l -2 3.464 C 18.247 8.22 18.129 8.288 18 8.288 h -3.792 l -2.896 5.017 C 11.245 13.42 11.124 13.484 11 13.484 z M 14.208 7.568 h 3.584 l 1.792 -3.104 L 17.792 1.36 h -3.584 l -1.792 3.104 L 14.208 7.568 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "_Transparent_Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -16,
    y: -16,
    rx: 0,
    ry: 0,
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.beb4df914b03e2fced8d5dc4a6275c59.svg";
export { ForwardRef as ReactComponent };